/** Warm lazy chunks for education tabs so tab switches do not flash Suspense fallback. */
export function preloadEducationRouteModules(): void {
  void import("./UseCases/Educations/Education");
  void import("./pages/Education");
  void import("./UseCases/Questions/QuestionsPractice");
  void import("./UseCases/Theory/TheoryList");
  void import("./UseCases/Practice/PracticeExam");
  void import("./pages/CertificatePage");
  void import("./UseCases/Documents/DocumentsList");
}
